import { Parallax, ParallaxProvider } from 'react-scroll-parallax'
import HomeSection from '@/Components/IntegraAI/HomeSection'
import EnterpriseAIDilemma from '@/Components/IntegraAI/EnterpriseAIDilemma'
import FeatureCards from '@/Components/IntegraAI/FeatureCards'
import FeaturesSection from '@/Components/IntegraAI/FeaturesSection'
import IntegrationSupport from '@/Components/IntegraAI/IntegrationSupport'
import EnterpriseCards from '@/Components/IntegraAI/EnterpriseCards'
import PricingTransparency from '@/Components/IntegraAI/PricingTransparency'
import ReadyToStart from '@/Components/IntegraAI/ReadyToStart'
import FAQs, { faqs } from '@/Components/Ai-Consultation/FAQs'
import ProductSeo from '@/Components/seo/ProductSeo'
import { PRODUCTS } from '@/lib/products'
import Reviews from '@/Components/newHomePage/Reviews'
import CustomPricingCard from '@/Components/common/CustomPricingCard'




export default function IntegraAi() {
    return (
        <ParallaxProvider>
            {/* Title, description, OG tags and schema all come from lib/products.js via ProductSeo */}
            <ProductSeo product={PRODUCTS.integraAi} faqs={faqs} />
            <div className='bg-[#141b2c] max-w-[2200px] mx-auto'>
                <Parallax speed={-20}>
                    <div className='max-w-full'> 
                    <HomeSection />
                    </div>
                </Parallax>
            </div>
            <div className='bg-white max-w-[1750px] mx-auto'>
                <Parallax speed={10}>
                    <EnterpriseAIDilemma />
                </Parallax>

                    <FeatureCards />
               

                <Parallax speed={12}>
                    <FeaturesSection />
                </Parallax>

                <Parallax speed={-5}>
                    <IntegrationSupport />
                </Parallax>

                <Parallax speed={7}>
                    <EnterpriseCards />
                </Parallax>

                <Parallax speed={-10}>
                    <PricingTransparency />
                </Parallax>

                <Parallax speed={7}>
                    <div className="max-w-[1750px] mx-auto px-14 pb-10 md:pb-0">
                        <Reviews />
                    </div>
                    <div className='bg-gradient-to-br from-[#141b2c] to-[#24056d]'>
                    <CustomPricingCard   ctaHref = "/contact?ref=integra-ai"/>
                    </div>
                    <FAQs />
                </Parallax>

                <div className='bg-black'>
                    <ReadyToStart />
                </div>
            </div>
        </ParallaxProvider>
    )
}
